'use client';

import { cj } from 'src/utils/classNames';
import useSyncLstMetricsStore from 'src/stores/circuitStore/useSyncLstMetricsStore';
import PageContentWrapper from '../Layouts/PageContentWrapper';
import { EarnPageHeadSection } from './EarnPageHeadSection';
import { EarnPageNavSection } from './EarnPageNavSection';
import { EARN_PAGE_HEAD_SECTION_ID } from './constants';
import { EARN_HEAD_STICKY_Z_INDEX } from './BorrowLend/constant';

const DriftEarnPage = ({ children }: { children: React.ReactNode }) => {
	useSyncLstMetricsStore();

	return (
		<PageContentWrapper maxWidth={1280} className="bg-main-bg">
			<div className="flex h-full w-full flex-col overflow-visible">
				<div className="grid grid-cols-12 pb-3xl">
					<EarnPageHeadSection className="col-span-12" />
					<EarnPageNavSection
						id={EARN_PAGE_HEAD_SECTION_ID}
						className={cj(
							'col-span-12 bg-main-bg',
							'sticky top-0',
							'mb-md sm:mb-xl',
							EARN_HEAD_STICKY_Z_INDEX
						)}
					/>

					{children}
				</div>
			</div>
		</PageContentWrapper>
	);
};

export default DriftEarnPage;
